import React from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import Typography from "@material-ui/core/Typography";
import IconButton from "@material-ui/core/IconButton";
import { makeStyles } from "@material-ui/core/styles";
import { X as CloseXIcon } from "lucide-react";

import { i18n } from "../../translate/i18n";
import ChatiaDialogActions from "../ChatiaDialogActions";

const useStyles = makeStyles(theme => {
	const isDark = theme.mode === "dark" || theme.palette.type === "dark";
	return ({
	dialogPaper: {
		borderRadius: "21px 21px 12px 12px !important",
		maxHeight: "85vh !important",
		display: "flex !important",
		flexDirection: "column !important",
		overflow: "hidden !important",
		background: `${isDark ? "#121212" : "#ffffff"} !important`,
		"& .MuiDialogContent-root": {
			flex: 1,
			overflowY: "auto !important",
			overflowX: "hidden",
			background: isDark ? "#121212" : "#ffffff",
			...theme.scrollbarStyles,
		},
		"& .MuiDialogActions-root": {
			flexShrink: 0,
			background: isDark ? "#121212" : "#ffffff",
			borderTop: `1px solid ${isDark ? "rgba(255,255,255,0.06)" : "rgba(0,0,0,0.06)"}`,
		},
	},
	header: {
		...(theme.chatiaDS?.header || {
			display: "flex",
			alignItems: "center",
			justifyContent: "space-between",
			padding: "14px 16px",
			background: theme.palette.primary.main,
			color: theme.palette.primary.contrastText || "#fff",
			borderBottom: "none",
		}),
		flexShrink: 0,
	},
	headerTitle: {
		...(theme.chatiaDS?.headerTitle || {
			fontWeight: 600,
			fontSize: 15,
			color: "inherit",
		}),
	},
	closeButton: {
		backgroundColor: "rgba(255, 255, 255, 0.08)",
		color: "#ffffff",
		transition: "all 0.2s ease",
	},
	});
});

const ConfirmationModal = ({ title, children, open, onClose, onConfirm }) => {
	const classes = useStyles();

	return (
		<Dialog
			open={open}
			onClose={() => onClose(false)}
			aria-labelledby="confirm-dialog"
			maxWidth="sm"
			fullWidth
			PaperProps={{ className: classes.dialogPaper }}
		>
			<div className={classes.header}>
				<Typography className={classes.headerTitle}>{title}</Typography>
				<IconButton
					size="small"
					onClick={() => onClose(false)}
					className={classes.closeButton}
					onMouseEnter={(e) => {
						e.currentTarget.style.backgroundColor = "rgba(255, 255, 255, 0.18)";
					}}
					onMouseLeave={(e) => {
						e.currentTarget.style.backgroundColor = "rgba(255, 255, 255, 0.08)";
					}}
				>
					<CloseXIcon size={18} />
				</IconButton>
			</div>
			<DialogContent dividers>
				<Typography>{children}</Typography>
			</DialogContent>
			<ChatiaDialogActions
				type="button"
				onClick={() => {
					onClose(false);
					onConfirm();
				}}
				saveText={i18n.t("confirmationModal.buttons.confirm")}
			/>
		</Dialog>
	);
};

export default ConfirmationModal;
